var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { jsx, jsxs } from "react/jsx-runtime";
import { SessionReplayExperimentModel } from "./hooks/useExperiments";
import ReactDOM from "react-dom";
import { SessionReplayCoreModel } from "./hooks/useSessionReplayCore";
import SessionReplayUserResearchPortal from "./containers/session-replay-user-research-portal";
import SessionReplayDebugMode from "./containers/session-replay-debug-mode-portal";
import ErrorBoundaryFunctionalComponent from "./components/ErrorBoundary";
import {
  SessionReplayGeneralConfigModel
} from "./hooks/useGeneralConfigs";
const SessionReplay = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  if (!((_a = props == null ? void 0 : props.sessionReplayUserResearchConfigFromBackend) == null ? void 0 : _a.enableSessionReplay)) {
    return null;
  }
  console.log("[SR] Session Replay Renders");
  console.log("[SR] Props", props);
  const internalExperiments = {
    allExperiments: (_b = props == null ? void 0 : props.sessionReplayUserResearchConfigFromBackend) == null ? void 0 : _b.experiments,
    // MOCK
    // allExperiments: props?.sessionReplayUserResearchConfigFromBackend?.experiments?.map((exp) => {
    //   return {
    //     ...exp,
    //     journeyEntryPage: 'xx'
    //   };
    // }),
    relevantExperiments: [],
    enableSessionReplay: (_c = props == null ? void 0 : props.sessionReplayUserResearchConfigFromBackend) == null ? void 0 : _c.enableSessionReplay
  };
  const sessionReplayGeneralConfig = {
    userLang: props.sessionReplayLang,
    uid: props.sessionReplayUid,
    userCountry: props.sessionReplayUserCountry,
    btm: props.btm,
    teaCollectEvent: props.teaCollectEvent,
    teaCallbackOn: props.teaCallbackOn,
    teaCallbackOff: props.teaCallbackOff,
    appId: props.appId,
    skipExperimentAuthorisation: props.sessionReplayUserResearchSkipExperimentAuthorisation,
    teaSessionId: props.teaSessionId
  };
  const toEnableUserResearchSessionReplay = ((_d = props == null ? void 0 : props.sessionReplayUserResearchConfigFromBackend) == null ? void 0 : _d.enableSessionReplay) && ((_e = props == null ? void 0 : props.mode) == null ? void 0 : _e.includes("user-research"));
  const toEnableUserJourneySessionReplay = ((_f = props == null ? void 0 : props.sessionReplayUserResearchConfigFromBackend) == null ? void 0 : _f.enableSessionReplay) && ((_g = props == null ? void 0 : props.mode) == null ? void 0 : _g.includes("user-journey"));
  const toEnableOncallSessionReplay = (_h = props == null ? void 0 : props.mode) == null ? void 0 : _h.includes("oncall");
  if (!toEnableUserResearchSessionReplay && !toEnableUserJourneySessionReplay && !toEnableOncallSessionReplay) {
    return null;
  }
  const getRegion = () => {
    if (props.sessionReplayUserCountry.toUpperCase() === "US") {
      if (props.appId === 5969) {
        return "US-BDEE";
      }
    }
    return props.sessionReplayUserCountry;
  };
  return /* @__PURE__ */ jsx(ErrorBoundaryFunctionalComponent, { children: /* @__PURE__ */ jsx(SessionReplayGeneralConfigModel.Provider, { initialState: sessionReplayGeneralConfig, children: /* @__PURE__ */ jsx(SessionReplayCoreModel.Provider, { initialState: { region: getRegion() }, children: /* @__PURE__ */ jsxs(SessionReplayExperimentModel.Provider, { initialState: internalExperiments, children: [
    toEnableUserResearchSessionReplay ? /* @__PURE__ */ jsx(
      SessionReplayUserResearchPortal,
      {
        customAuthorisationComponent: (_i = props == null ? void 0 : props.sessionReplayUserResearchAuthorisationComponent) != null ? _i : void 0,
        enableDevTool: props == null ? void 0 : props.enableDevTool
      }
    ) : null,
    toEnableOncallSessionReplay ? /* @__PURE__ */ jsx(
      SessionReplayDebugMode,
      {
        customAuthorisationComponent: (_j = props == null ? void 0 : props.sessionReplayOncallAuthorisationComponent) != null ? _j : void 0,
        customIndicatorComponent: (_k = props == null ? void 0 : props.sessionReplayOncallIndicatorComponent) != null ? _k : void 0
      }
    ) : null
  ] }) }) }) });
};
const replayRender = (props) => {
  try {
    const div = document.createElement("div");
    document.body.appendChild(div);
    ReactDOM.render(/* @__PURE__ */ jsx(SessionReplay, __spreadValues({}, props)), div);
  } catch (e) {
  }
};
var src_default = replayRender;
import {
  useGetExternalRecordingInfo,
  saveExternalBlackBoxRecording
} from "./hooks/useExternalGetRecordingInfo";
export {
  SessionReplay,
  src_default as default,
  replayRender,
  saveExternalBlackBoxRecording,
  useGetExternalRecordingInfo
};
